import { basicListAddEditDltInitialState } from '../../../../../stateManagement/reduxUtil';
import { fiedForceLetterActionTypes } from '../actions/actionTypes';

const insertUpdateData = (action) => ({
  listData: action.data,
  listRequestError: null,
  listRequestProcessedOn: new Date(),
  loading: false,
});

const FieldForceLetterReducer = (state = { ...basicListAddEditDltInitialState }, action = null) => {
  switch (action.type) {
    // reset Upset Value
    case fiedForceLetterActionTypes.RESET_UPSERT_VALUE:
      return {
        ...state,
        upsertRequest: action.data.upsertRequest,
        upsertRequestError: action.data.upsertRequestError,
        upsertRequestedOn: action.data.upsertRequestedOn,
        upsertRequestProcessedOn: action.data.upsertRequestProcessedOn,
        upsertData: action.data.upsertData,
      };
    // reset Delete Value
    case fiedForceLetterActionTypes.RESET_DELETE_VALUE:
      return {
        ...state,
        deleteRequest: action.data.deleteRequest,
        deleteRequestError: action.data.deleteRequestError,
        deleteRequestedOn: action.data.deleteRequestedOn,
        deleteRequestProcessedOn: action.data.deleteRequestProcessedOn,
        deleteData: action.data.deleteData,
      };
    case fiedForceLetterActionTypes.GET_FF_LETTER_LIST_RES:
      return {
        ...state,
        ...insertUpdateData(action),
      };
    // Configure Page Details
    case fiedForceLetterActionTypes.SET_FF_LETTER_DETAILS_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case fiedForceLetterActionTypes.RESET_UPSERT_ERROR:
      return {
        ...state,
        upsertRequestError: [],
      };
    case fiedForceLetterActionTypes.RESET_SERVER_VALUE:
      return {
        ...state,
        serverRequestError: action.data && action.data.serverRequestError,
      };
    default:
      return state;
  }
};

export default FieldForceLetterReducer;
